<template>
  <div
    class="c-page-results-counter text-14 font-bold text-center pb-{25px}">
    {{ $t('functional.pageResultsCount', { from: numberFormat(from), to: numberFormat(to), total: numberFormat(total), type: (type || $t('functional.results')).toLowerCase() }) }}
  </div>
</template>

<script>
export default {
  name: 'PageResultsCounter',
  props: {
    from: {
      type: Number,
      required: true,
    },
    to: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
  },
  methods: {
    numberFormat(x) {
      return Intl.NumberFormat(this.$i18n.locale).format(x);
    },
  },
};
</script>

